import { Container as NbContainer } from '@fhs-legacy/native-base';

import { addWithConfig } from '../../utils';

export const Container = NbContainer;

export default addWithConfig(Container);
